module.exports = __webpack_public_path__ + "files/a1c5f0f7484bbe3f8eab6de5a9dbf5cc.png";